import MuiCheckbox, {CheckboxProps} from '@mui/material/Checkbox';
import FormControlLabel, {FormControlLabelProps} from '@mui/material/FormControlLabel';
import makeStyles from '@mui/styles/makeStyles';
import Typography from '@mui/material/Typography';
import classNames from 'classnames';
import React from 'react';
import {readOnlyContext} from 'common/context/ReadOnlyContext';

type Props = {
   name: string;
   label?: React.ReactNode;
   error?: any;
   className?: string;
   disabled?: boolean;
   checked?: boolean;
   value?: any;
   autoFocus?: boolean;
   labelPlacement?: FormControlLabelProps['labelPlacement'];
   onChange?: CheckboxProps['onChange'];
   onBlur?: CheckboxProps['onBlur'];
   defaultChecked?: CheckboxProps['defaultChecked'];
   inputRef?: CheckboxProps['inputRef'];
   inverse?: boolean;
};

const useStyles = makeStyles((theme) => ({
   invalid: {
      color: theme.palette.error.main,
   },
   centerText: {
      textAlign: 'center',
   },
}));

const Checkbox = ({
   name,
   className,
   label,
   disabled,
   checked: _checked,
   labelPlacement,
   error,
   value,
   autoFocus,
   onChange,
   onBlur,
   defaultChecked,
   inputRef,
   inverse,
}: Props) => {
   const classes = useStyles();
   const readOnly = React.useContext(readOnlyContext);
   const _onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      // e.persist();
      const checked = inverse ? !e?.target?.checked : e?.target?.checked;
      const ev = {
         ...e,
         target: {
            ...e.target,
            checked,
            name: e.target.name,
            id: e.target.id,
            value: e.target.value,
            type: e.target.type,
            nodeType: e.target.nodeType,
         },
      };
      onChange && onChange(ev, checked);
   };
   const checked = inverse ? !_checked : _checked;

   return (
      <FormControlLabel
         disabled={disabled || readOnly}
         labelPlacement={labelPlacement}
         className="form-checkbox"
         classes={{
            labelPlacementTop: classes.centerText,
         }}
         control={
            <MuiCheckbox
               autoFocus={autoFocus}
               inputProps={{
                  autoFocus,
               }}
               defaultChecked={defaultChecked}
               className={classNames(className, {[classes.invalid]: error})}
               name={name}
               value={value}
               checked={checked}
               onChange={_onChange}
               onBlur={onBlur}
               inputRef={inputRef}
            />
         }
         label={<Typography variant="label">{label}</Typography>}
      />
   );
};

export default React.memo(Checkbox);
